import QuinielaGrupoPopUp from './QuinielaGrupoPopUp';
export default QuinielaGrupoPopUp;